<div id="location-information-container" class="form-container" style="position: relative">
  @if (isLoading) {
  <div id="location-information-spinner" class="spinner-overlay">
    <mat-spinner diameter="40"></mat-spinner>
  </div>
  }
  <div id="location-information-content" class="tab-content" [class.blur]="isLoading">
    <mat-accordion id="location-information-accordion" multi="true">
      <mat-expansion-panel id="location-details-panel" [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mic-icon class="mr-2" icon="place" fontSet="outlined"></mic-icon>
            {{ translationService.translate('locationDetailsText') }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-divider />
        <form id="location-details-form" [formGroup]="locationDetailsForm">
          <mat-card id="location-details-card" class="custom-card-no-shadow view-component">
            <div class="filter-container">
              <mat-form-field subscriptSizing="dynamic" class="location-item">
                <mat-label> {{ translationService.translate('casingLocationText') }}</mat-label>
                <input matInput type="text" id="location-info-casingLocation" formControlName="casingLocation" placeholder="-" readonly />
              </mat-form-field>
              <mat-form-field subscriptSizing="dynamic" class="location-item">
                <mat-label> {{ translationService.translate('currentPostText') }}</mat-label>
                <input
                  id="location-info-currentPost"
                  matInput
                  type="text"
                  [value]="getTranslatedPost(locationDetailsForm.get('currentPost')?.value)"
                  placeholder="-"
                  readonly
                />
              </mat-form-field>
              <mat-form-field subscriptSizing="dynamic" class="location-item">
                <mat-label> {{ translationService.translate('plantRetreadedText') }}</mat-label>
                <input matInput type="text" id="location-info-plantRetreaded" formControlName="plantRetreaded" placeholder="-" readonly />
              </mat-form-field>
            </div>
          </mat-card>
        </form>
      </mat-expansion-panel>

      <mat-expansion-panel id="shop-floor-updates-panel" [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mic-icon class="mr-2" icon="factory" fontSet="outlined"></mic-icon>
            {{ translationService.translate('shopFloorUpdatesText') }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-divider></mat-divider>
        <form id="shop-floor-updates-form" [formGroup]="shopFloorUpdatesForm">
          <mat-card id="shop-floor-updates-card" class="custom-card-no-shadow view-component">
            <div class="filter-container">
              <mat-form-field subscriptSizing="dynamic" class="sfupdate-item1">
                <mat-label>{{ translationService.translate('ciaResultsText') }}</mat-label>
                <input matInput type="text" id="location-info-CIAResult" formControlName="CIAResult" placeholder="-" readonly />
              </mat-form-field>
              <mat-form-field subscriptSizing="dynamic" class="sfupdate-item1">
                <mat-label>{{ translationService.translate('xRaysResultsText') }}</mat-label>
                <input matInput type="text" id="location-info-xRaysResult" formControlName="xRaysResult" placeholder="-" readonly />
              </mat-form-field>
              <mat-form-field subscriptSizing="dynamic" class="sfupdate-item2">
                <mat-label>{{ translationService.translate('finalSpeedIndexText') }}</mat-label>
                <input matInput type="text" id="location-info-finalSpeedIndex" formControlName="finalSpeedIndex" placeholder="-" readonly />
              </mat-form-field>
              <mat-form-field subscriptSizing="dynamic" class="sfupdate-item2">
                <mat-label>{{ translationService.translate('circumferenceText') }}</mat-label>
                <input matInput type="text" id="location-info-circumference" formControlName="circumference" placeholder="-" readonly />
              </mat-form-field>
            </div>
            <div class="filter-container mt-3">
              <mat-form-field subscriptSizing="dynamic" class="sfupdate-item2">
                <mat-label>{{ translationService.translate('widthText') }}</mat-label>
                <input matInput type="text" id="location-info-width" formControlName="width" placeholder="-" readonly />
              </mat-form-field>
              <mat-form-field subscriptSizing="dynamic" class="sfupdate-item2">
                <mat-label>{{ translationService.translate('treadDesignText') }}</mat-label>
                <input matInput type="text" id="location-info-treadDesc" formControlName="treadDesc" placeholder="-" readonly />
              </mat-form-field>
              @if (display()) {
              <mat-form-field subscriptSizing="dynamic" class="sfupdate-item1">
                <mat-label>{{ translationService.translate('adjustmentPercentageText') }}</mat-label>
                <input matInput type="text" id="location-info-adjPercent" formControlName="adjPercent" placeholder="-" readonly />
              </mat-form-field>
              } @if (display()) {
              <mat-form-field subscriptSizing="dynamic" class="sfupdate-item1">
                <mat-label>{{ translationService.translate('adjustmentReasonText') }}</mat-label>
                <input matInput type="text" id="location-info-adjReason" formControlName="adjReason" placeholder="-" readonly />
              </mat-form-field>
              }
            </div>
          </mat-card>
        </form>
      </mat-expansion-panel>

      <mat-expansion-panel id="pos-updates-panel" [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mic-icon class="mr-2" icon="point_of_sale" fontSet="outlined"></mic-icon>
            {{ translationService.translate('posUpdatesText') }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-divider />
        <form id="pos-updates-form" [formGroup]="posUpdatesForm">
          <mat-card id="pos-updates-card" class="custom-card-no-shadow view-component">
            <div class="filter-container">
              <mat-form-field subscriptSizing="dynamic" class="location-item">
                <mat-label>{{ translationService.translate('posResultsText') }}</mat-label>
                <input matInput type="text" id="location-info-POSResults" formControlName="POSResults" placeholder="-" readonly />
              </mat-form-field>
              <mat-form-field subscriptSizing="dynamic" class="location-item">
                <mat-label>{{ translationService.translate('invoiceDateText') }}</mat-label>
                <input matInput type="text" id="location-info-invoiceDate" formControlName="invoiceDate" placeholder="-" readonly />
              </mat-form-field>
              <mat-form-field subscriptSizing="dynamic" class="location-item">
                <mat-label>{{ translationService.translate('invoiceNumberText') }}</mat-label>
                <input matInput type="text" id="location-info-invoiceNumber" formControlName="invoiceNumber" placeholder="-" readonly />
              </mat-form-field>
            </div>
          </mat-card>
        </form>
      </mat-expansion-panel>

      <mat-expansion-panel id="pack-list-information-panel" [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mic-icon class="mr-2" icon="list_alt" fontSet="outlined"></mic-icon>
            {{ translationService.translate('packListInformationText') }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-divider></mat-divider>
        <form id="pack-list-information-form" [formGroup]="packlistInformationForm">
          <mat-card id="pack-list-information-card" class="custom-card-no-shadow view-component">
            <div class="filter-container">
              <mat-form-field subscriptSizing="dynamic" class="location-item">
                <mat-label>{{ translationService.translate('packListText') }}</mat-label>
                <input matInput type="text" id="location-info-packList" formControlName="packList" placeholder="-" readonly />
              </mat-form-field>
              <mat-form-field subscriptSizing="dynamic" class="location-item">
                <mat-label>{{ translationService.translate('packListStatusText') }}</mat-label>
                <input matInput type="text" id="location-info-packListStatus" formControlName="packListStatus" placeholder="-" readonly />
              </mat-form-field>
            </div>
          </mat-card>
        </form>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>
